import { render, staticRenderFns } from "./GwLanguage.html?vue&type=template&id=009bf1e4&"
import script from "./GwLanguage.vue?vue&type=script&lang=js&"
export * from "./GwLanguage.vue?vue&type=script&lang=js&"
import style0 from "./GwLanguage.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports